<template>
    <div 
        class="svg-icon" 
        v-html="svg" />  
</template>

<script>
export default {
    name: 'Icon',

    props: {
        svg: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="less" scoped>

    @import "../styles/globals.less";

    .svg-icon {
        width: @icon-width;
        height: @icon-width;
    }
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue